import React from 'react'

const Comment = ({ comment, user, removeComment }) => {

    let day
    let month
    let year
    let secondsPast
    let time

    function timeSince(timeStamp) {
        let now = new Date();
        let _timeStamp = new Date(timeStamp)
        secondsPast = (now.getTime() - timeStamp) / 1000;
        if (secondsPast < 60) {
            return parseInt(secondsPast) + 's';
        }
        if (secondsPast < 3600) {
            return parseInt(secondsPast / 60) + 'm';
        }
        if (secondsPast <= 86400) {
            return parseInt(secondsPast / 3600) + 'h';
        }
        if (secondsPast > 86400) {
            day = _timeStamp.getDate();
            month = _timeStamp.toDateString().match(/ [a-zA-Z]*/)[0].replace(" ", "");
            year = _timeStamp.getFullYear() === now.getFullYear() ? "" : " " + _timeStamp.getFullYear();
            return day + " " + month + year;
        }
    }

    if (comment) {
        time = timeSince(comment.created)

    }

    


    return (
        <div className={`px-5 py-2  rounded animate__animated animate__slideInRight overflow-hidden ${user.id === comment.userId ? 'dark:bg-orange-800' : 'dark:bg-neutral-600'}`}>
            <div className='flex justify-between'>
                <span className='text-gray-300 text-md '>{comment.fullName}</span>
                <div className='flex gap-2'>
                    <span className='text-gray-300 text-xs '>{time}</span>
                    {user.id === comment.userId && <span className='text-red-400 text-sm cursor-pointer' onClick={() => removeComment(comment.id)}><i className="fa-solid fa-trash"></i></span>}

                </div>

            </div>
            <p className='text-sm dark:text-white'>{comment.comment}</p>
        </div>
    )
}

export default Comment